module.exports = __webpack_public_path__ + "media/marker.98624fc2.svg";